import { BlockTypes } from './';
export function isBlock(block) {
    return block.type in BlockTypes;
}
export function isNewMetrikaFormat(metrika) {
    return Boolean(Array.isArray(metrika) && metrika.length && typeof metrika[0] === 'object');
}
